module.exports = __webpack_public_path__ + "static/media/Icons_Idle_06_Dollar Sign.042f6d6a.svg";